import React from 'react'
import styled from 'styled-components'
import { Wrapper, H } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'

const StyledDiv = styled.div<{
  backgroundColor: string
}>`
  background-color: ${(props) => props.backgroundColor};
`
const StyledText = styled.p`
  color: ${COLOR.BLACK};
`

const StyledWrapper = styled(Wrapper)`
  padding-top: ${GTR.M};
  padding-bottom: ${GTR.M};
`

export type MessageBannerProps = {
  backgroundColor?: string
  partnerName: string
  children: string
  titleColor?: string
}

const MessageBanner = ({
  backgroundColor = COLOR.GREY.LIGHT,
  partnerName,
  children,
  titleColor = COLOR.ACCENT.BRAND,
}: MessageBannerProps): React.ReactElement => (
  <StyledDiv backgroundColor={backgroundColor}>
    <StyledWrapper container color={COLOR.BLACK}>
      <H color={titleColor} tag="h3" size="S" margin="0">
        A message from {partnerName}
      </H>
      <StyledText>{children}</StyledText>
    </StyledWrapper>
  </StyledDiv>
)

export default MessageBanner
